export default __webpack_public_path__ + "static/media/CapaMore.2edbb214.svg";